module.exports = __webpack_public_path__ + "beb2c5aba8661021e10b1e5d5cf198bb.pdf";